import { createFileRoute } from "@tanstack/react-router";

import { WorkforcePage } from "@/features/insights/workforce";

export const Route = createFileRoute("/_authenticated/intel/workforce")({
  component: WorkforcePage,
});
